import { service } from './service';
import { SORT_ORDER } from '@/resources/Constants'
import _ from 'lodash';
import { mapGridPagingState, getGridPagingParams } from '../../shared/utils';

const PAGE_SIZE = 50;
const DEFAULT_SORT_BY = 'firstName';
const DEFAULT_SORT_ORDER = SORT_ORDER.ASC;

const state = {
  all: {},
  contacts: [],
  primaryContact: 0,
  paging: {
    ...getGridPagingParams(DEFAULT_SORT_ORDER, 'firstName'),
    filters: {
      firstName: null
    }
  },
  pageInfo: {
    totalItems: 0,
    totalPages: 0,
    pageNumber: 1,
    pageSize: PAGE_SIZE,
  },
  sortBy: DEFAULT_SORT_BY,
  sortOrder: DEFAULT_SORT_ORDER,
  contactNotes: [],
  contactRoleTypes: [],
  companyBusinessUnits: [],
  contactLookups: [],
};

const getters = {
  contacts: state => state.contacts,
  primaryContact: state => state.primaryContact,
  pageInfo: state => state.pageInfo,
  sortBy: state => state.sortBy,
  sortOrder: state => state.sortOrder,
};

const actions = {
  async getContacts(
    { commit, state },
    {
      pageNumber = state.paging.pageNumber,
      pageSize = state.paging.pageSize,
      sortBy = state.paging.sortBy,
      sortOrder = state.paging.sortOrder,
      filters = state.paging.filters,
      companyId
    } = {},
  ) {
    const results = await service.getContacts(
      companyId,
      pageNumber,
      pageSize,
      sortBy,
      sortOrder,
      filters
    );

    // results.paging = { ...results.paging, sortBy: results.paging.sort };
    // delete results.paging.sort;

    commit('setContacts', results);
  },

  async setPrimaryContact({ state, dispatch }, id) {
    // setting primary location with 2 ids to patch
    await service.setPrimaryContact([state.primaryContact, id]);

    // retrieving data using the company Id
    dispatch('getContacts', { companyId: state.contacts[0].companyId });
  },

  async saveCompanyContactRecord({ state, commit, dispatch }, spObj) {
    console.log('start saveCompanyContactRecord', spObj.id);
    let result = null;
    let isUpdateRecord = (!_.isUndefined(spObj.id) && spObj.id > 0);

    if (isUpdateRecord) {
      result = await service.updateCompanyContactRecord(spObj);
    } else {
      result = await service.saveCompanyContactRecord(spObj);
    }


    if (result && result.isPrimary && result.id != state.primaryContact) {
      await service.setPrimaryContact([state.primaryContact, result.id]);
    }

    commit('saveResponse', result);
    dispatch('getContacts', { companyId: result.companyId });
  },

  async getContactNotes({ commit }, id) {
    const notes = await service.getContactNotes(id);
    commit('setNotes', notes);
  },

  async saveContactNotes({ }, noteObj) {
    await service.saveContactNotes(noteObj);

    return true;
  },

  async deleteContact({ dispatch }, ids) {
    // console.log(state.company.id, 'ID');
    await service.deleteContact(ids[0]);

    // retrieving data using the company Id
    dispatch('getContacts', { companyId: ids[1] });
  },

  async deleteContactNote({ }, id) {
    await service.deleteContactNote(id);

    return true;
  },

  async getContactRoleTypesData({ commit }) {
    const contactRoleTypesData = await service.getContactRoleTypes();
    commit('setContactRoleTypes', contactRoleTypesData);
  },

  async getCompanyBusinessUnitData({ commit }, companyId) {
    const companyBusinessUnitData = await service.getCompanyBusinessUnitByCompanyId(companyId);
    commit('setCompanyBusinessUnit', companyBusinessUnitData);
  },

  async getContactsLookupData({ commit }, companyId) {
    const contactLookupData = await service.getContactsLookupByCompanyId(companyId);
    commit('setContactLookup', contactLookupData);
  },

  async resetContactPaging({ commit }) {
    commit('resetContactPagingState');
  }
};

const mutations = {
  resetContactPagingState(state) {
    state.paging = {
      ...getGridPagingParams(DEFAULT_SORT_ORDER, 'firstName'),
      filters: {
        firstName: null,
      }
    };
    state.contacts = [];
  },

  saveResponse(state, payload) {
    state.saveResponse = payload;
  },
  setContacts(state, payload) {

    const pagingData = payload && payload.paging;

    state.contacts = payload && payload.items;

    state.paging = mapGridPagingState(
      state.paging,
      pagingData
    );

    // ['sortBy', 'sortOrder', 'totalItems', 'pageSize', 'pageNumber'].forEach(key => {
    //   if (payload.paging.hasOwnProperty(key)) {
    //     state.paging[key] = payload.paging[key];
    //   }
    // });

    if (!_.isEmpty(state.contacts)) {
      const primaryObj = state.contacts.filter(contact => contact.isPrimary);
      // If no primary contact, then the first entry will have the auto primary location
      state.primaryContact = (_.isEmpty(primaryObj)) ? 0 : primaryObj[0].id;
    }

  },
  setNotes(state, payload) {
    let notesArr = [];
    payload.list.forEach(note => {
      let noteTemp = {
        id: note.id,
        notes: note.notes,
        user: 'Test User',
        date: new Date(note.dateCreated).toLocaleDateString()
      }

      notesArr.push(noteTemp);
    });

    notesArr.sort(function (a, b) {
      return a.id - b.id;
    });

    state.contactNotes = notesArr;
  },

  setContactRoleTypes(state, payload) {
    state.contactRoleTypes = payload;
  },

  setCompanyBusinessUnit(state, payload) {
    state.companyBusinessUnits = payload;
  },

  setContactLookup(state, payload) {
    state.contactLookups = [];

    if (payload) {
      let convertedObjArr = [];

      payload.forEach(a => {
        if (a.contactFullName) {
          convertedObjArr.push({ value: a.id, text: a.contactFullName });
        }
      });

      state.contactLookups = convertedObjArr;
    }

  }

};

const contacts = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default contacts;
